/**
 * Flickity Carousel Library - JavaScript
 * Loaded conditionally via ACF theme options or when patterns require it
 */

import $ from 'jquery';

// Import Flickity and its components
const jQueryBridget = require('jquery-bridget');
const Flickity = require('flickity');
require('flickity-imagesloaded');
require('flickity-fullscreen');
require('flickity-as-nav-for');
require('flickity-bg-lazyload');
require('flickity-hash');
require('flickity-fade');
require('flickity-sync');

// Make Flickity a jQuery plugin
jQueryBridget('flickity', Flickity, $);

// Expose Flickity globally for patterns and inline scripts
if (typeof window !== 'undefined') {
  window.Flickity = Flickity;

  // Ensure jQuery has flickity method available globally
  if ($) {
    window.jQuery = $;
  }
}

// Optional: Initialize any flickity carousels with data attributes
document.addEventListener('DOMContentLoaded', () => {
  // Auto-initialize carousels with data-flickity attribute
  const $autoFlickity = $('[data-flickity]');
  if ($autoFlickity.length && $.fn.flickity) {
    $autoFlickity.each(function() {
      const $this = $(this);
      const options = $this.data('flickity') || {};
      $this.flickity(options);
    });
  }
});

export default Flickity;
